import { apiFetch } from './client';
import type {
  CloseOrderData,
  CloseOrderPayload,
  CreateFlowAData,
  CreateFlowAPayload,
  CreateFlowBData,
  CreateFlowBPayload,
  ListOrdersData,
  ListOrdersQuery,
  Order,
} from '../types/api';

export function listOrders(query: ListOrdersQuery = {}) {
  return apiFetch<ListOrdersData>('/api/orders', { query: { ...query } });
}

export function getOrder(id: string) {
  return apiFetch<Order>(`/api/orders/${id}`);
}

export function createFlowAOrder(payload: CreateFlowAPayload) {
  return apiFetch<CreateFlowAData>('/api/orders/flow-a', { method: 'POST', body: payload });
}

export function createFlowBOrder(payload: CreateFlowBPayload) {
  return apiFetch<CreateFlowBData>('/api/orders/flow-b', { method: 'POST', body: payload });
}

export function closeOrder(id: string, payload: CloseOrderPayload) {
  return apiFetch<CloseOrderData>(`/api/orders/${id}/close`, { method: 'POST', body: payload });
}

export function refreshOrder(id: string) {
  return apiFetch<Order>(`/api/orders/${id}/refresh`, { method: 'POST' });
}
